// extracted by mini-css-extract-plugin
export default {"control":"AddMovie_control__tG5Yv"};